import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    kitchen: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M18,2V8H16V2H18M13,2V8H11V2H13M8,2V8H6V2H8M20,8V22H4V8H20M20,6H4C2.89,6 2,6.89 2,8V22A2,2 0 0,0 4,24H20A2,2 0 0,0 22,22V8C22,6.89 21.11,6 20,6Z"/>
      </svg>
    ),
    local_laundry_service: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M9.17,16.83L7.76,15.42L12,11.17L16.24,15.41L14.83,16.82L12,14L9.17,16.83M18,2.01L6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2.01M18,20H6V16H18V20M18,14H6V10H18V14M18,8H6V4H18V8Z"/>
      </svg>
    ),
    ac_unit: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22,11H19.5L20.66,9.84L19.25,8.43L17.34,10.34L16.28,9.28L18.19,7.37L16.78,5.96L14.87,7.87H14.5A2.5,2.5 0 0,0 12,10.37V11H11.63A2.5,2.5 0 0,0 9.13,8.5V8.13L11.04,6.22L9.63,4.81L7.72,6.72L6.66,5.66L8.57,3.75L7.16,2.34L6,3.5V1H4V3.5L2.84,2.34L1.43,3.75L3.34,5.66L2.28,6.72L0.37,4.81L-1.04,6.22L0.87,8.13V8.5A2.5,2.5 0 0,0 3.37,11H4V12H3.37A2.5,2.5 0 0,0 0.87,14.5V14.87L-1.04,16.78L0.37,18.19L2.28,16.28L3.34,17.34L1.43,19.25L2.84,20.66L4,19.5V22H6V19.5L7.16,20.66L8.57,19.25L6.66,17.34L7.72,16.28L9.63,18.19L11.04,16.78L9.13,14.87H9.5A2.5,2.5 0 0,0 12,12.37V12H11.63A2.5,2.5 0 0,0 14.13,14.5H14.5L16.41,16.41L17.82,15L15.91,13.09L17,12L18.91,13.91L20.32,12.5L18.41,10.59H19.5L20.66,11.75L22.07,10.34L20.16,8.43H22V11Z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    home_repair_service: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M18,16V14.5L22,12.5V11H15L13.5,7H9.5L8,11H1V12.5L5,14.5V16H3V21H5V18H19V21H21V16H18M10.5,8H12.5L13.75,11H9.25L10.5,8Z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const ApplianceRepairLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'appliance repair business'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Refrigerator Emergency",
      time: "Sunday, 9:15 AM",
      customer: "My refrigerator stopped working overnight and all my food is going bad. Can someone come today?",
      response: "I understand this is urgent with food spoilage concerns. I can schedule our emergency technician for this afternoon. They'll bring common refrigerator parts and diagnostic equipment.",
      outcome: "$285 emergency repair",
      color: "blue"
    },
    {
      type: "Washer Repair",
      time: "Wednesday, 2:30 PM", 
      customer: "My washing machine is leaking water all over the floor. It won't spin and makes a loud noise.",
      response: "That sounds like a pump or bearing issue. I'll schedule our certified technician for tomorrow morning. They specialize in all washer brands and carry replacement pumps.",
      outcome: "$320 washer repair",
      color: "blue"
    },
    {
      type: "Dishwasher Service",
      time: "Friday, 6:45 PM",
      customer: "My dishwasher isn't cleaning properly and there's a weird smell. Can you fit me in this week?",
      response: "I can schedule a diagnostic service for tomorrow. Our technician will check the wash arms, filters, and drainage system. Most issues can be fixed same-day.",
      outcome: "$175 diagnostic + repair",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Emergency appliance calls used to stress me out. Now the AI handles them perfectly and I focus on the repairs, not the phone.",
      author: "Carlos M.",
      business: "Quick Fix Appliance Repair",
      result: "3x more emergency calls"
    },
    {
      quote: "The AI knows all the technical questions about brands and models. Customers get expert answers immediately instead of waiting for callbacks.",
      author: "Jennifer L.",
      business: "Expert Appliance Services",
      result: "90% fewer callbacks"
    },
    {
      quote: "Same-day appliance repairs are my specialty. The AI schedules urgent calls perfectly while I'm on other jobs.",
      author: "Mike R.",
      business: "Reliable Appliance Pros",
      result: "40% revenue increase"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'appliance repair business' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Receptionist for Appliance Repair Services - 24/7 Emergency Response",
    "description": "AI receptionist handles appliance repair calls for refrigerators, washers, dryers, dishwashers. Emergency service scheduling with technical expertise built-in.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for Appliance Repair | 24/7 Emergency Service"
        description="AI receptionist for appliance repair businesses. Handle refrigerator, washer, dryer, dishwasher repairs 24/7. Never miss emergency appliance service calls."
        keywords="appliance repair ai receptionist, refrigerator repair, washer dryer repair, dishwasher repair, emergency appliance service, 24/7 appliance repair"
        canonical="https://receptioneer.ai/appliance-repair"
        ogTitle="AI Receptionist for Appliance Repair - 24/7 Emergency Service"
        ogDescription="Handle emergency appliance repairs for refrigerators, washers, dryers, dishwashers with AI receptionist. 24/7 response with technical expertise."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-orange-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-orange-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🔧 For Appliance Repair Pros
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-orange-200">Emergency Repair</span>
              </h1>
              
              <p className="text-xl text-orange-100 mb-8 leading-relaxed">
                When appliances break, families need immediate help. Your AI receptionist handles refrigerator, washer, dryer, and dishwasher emergencies 
                <strong className="text-white"> 24/7 with technical expertise.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-orange-900 hover:bg-orange-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get Your AI Receptionist →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-orange-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Appliance Call
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-orange-200 text-sm">Emergency Ready</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-orange-200 text-sm">Per Month</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">0 sec</div>
                  <div className="text-orange-200 text-sm">Response Time</div>
                </div>
              </div>
            </div>

            <div className="bg-orange-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-green-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Customer:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className="rounded-lg p-3 bg-orange-50">
                    <div className="text-xs font-semibold mb-1 text-orange-600">AI Receptionist:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-green-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Job scheduled</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-orange-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Appliance Repair Needs AI */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Why Appliance Repair Needs <span className="text-orange-600">24/7 AI</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-red-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Emergency Situations</h3>
                <p className="text-gray-700 mb-6">
                  Broken refrigerators mean spoiled food. Leaking washers cause water damage. Failed dishwashers disrupt daily life. Customers need immediate help.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Refrigerator breakdowns</li>
                  <li>• Washer/dryer failures</li>
                  <li>• Dishwasher malfunctions</li>
                  <li>• HVAC unit issues</li>
                </ul>
              </div>

              <div className="bg-orange-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="schedule" className="w-8 h-8 text-orange-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Technical Questions</h3>
                <p className="text-gray-700 mb-6">
                  Customers need answers about models, warranties, parts availability, and repair costs before scheduling service calls.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Brand-specific knowledge</li>
                  <li>• Model compatibility</li>
                  <li>• Warranty coverage</li>
                  <li>• Repair vs replacement</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Same-Day Premium</h3>
                <p className="text-gray-700 mb-6">
                  Emergency appliance repairs command premium pricing. Missing these calls means losing $250-400+ jobs to competitors.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Emergency service premiums</li>
                  <li>• Same-day appointment fees</li>
                  <li>• Weekend/evening rates</li>
                  <li>• Lost calls = lost revenue</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Appliance Service Coverage */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Complete <span className="text-orange-600">Appliance Service</span> Coverage
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="kitchen" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Kitchen Appliances</h3>
                    <p className="text-gray-700">Refrigerators, dishwashers, ranges, ovens, microwaves, garbage disposals, and ice makers.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="local_laundry_service" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Laundry Appliances</h3>
                    <p className="text-gray-700">Washers, dryers, stackable units, and commercial laundry equipment for all major brands.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="ac_unit" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">HVAC & Cooling</h3>
                    <p className="text-gray-700">Window AC units, portable air conditioners, dehumidifiers, and ventilation systems.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="home_repair_service" className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Emergency Repairs</h3>
                    <p className="text-gray-700">Same-day service for urgent breakdowns, water leaks, electrical issues, and safety concerns.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="build" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Maintenance & Tune-ups</h3>
                    <p className="text-gray-700">Preventive maintenance, cleaning services, filter replacements, and performance optimization.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Installation Services</h3>
                    <p className="text-gray-700">New appliance installation, delivery coordination, and old appliance removal services.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Appliance Repair Pros Love <span className="text-orange-600">AI Receptionists</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-orange-50 rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="build" className="w-8 h-8 text-orange-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-orange-100 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-orange-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-16 px-6 bg-orange-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Emergency Call Pays for Everything
            </h2>
            
            <p className="text-xl text-orange-100 mb-8">
              Emergency appliance repairs typically cost $250-400+. One weekend call covers your entire monthly AI receptionist service.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-orange-100 mb-6">per month • unlimited calls • 24/7 appliance expertise</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-orange-900 hover:bg-orange-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Your AI Receptionist →
              </button>
            </div>
            
            <p className="text-orange-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Appliance Repair AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your appliance repair AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  placeholder="e.g. Carlos Martinez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  placeholder="carlos@appliancerepairpros.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-orange-900 hover:bg-orange-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Appliance Repair AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ApplianceRepairLanding;